import { COLORS } from "@app/constants";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { View } from "@/styles/reactnative";
import { CButton } from "../Common";

const AuthCheckBtns = () => {
  const { t } = useTranslation();
  const navigation = useNavigate();
  return (
    <View style={{ width: "100%", alignItems: "flex-start" }}>
      <CButton
        title={t("signUp")}
        onClick={() => {
          navigation("/signup");
        }}
        style={{
          background: COLORS.primary,
          color: COLORS.white,
          width: "100%",
          height: 35,
          borderRadius: 2,
        }}
      />
      <CButton
        title={t("login")}
        onClick={() => {
          navigation("/login");
        }}
        style={{
          background: COLORS.gray,
          color: COLORS.white,
          marginTop: 10,
          width: "100%",
          height: 35,
          borderRadius: 2,
        }}
      />
    </View>
  );
};

export default AuthCheckBtns;
